export default "__VITE_ASSET__CLOuZ9Ie__"